const ACTION = {
    UPDATE_PHONE_GROUP: 'UPDATE_PHONE_GROUP',
    UPDATE_PHONE_GROUP_ERROR_TEXT: 'UPDATE_PHONE_GROUP_ERROR_TEXT',
    UPDATE_SHOW_SMS_BOX: 'UPDATE_SHOW_SMS_BOX',
    UPDATE_VERIFY_PHONE_METHOD: 'UPDATE_VERIFY_PHONE_METHOD',
    UPDATE_VERIFY_INPUT_ERROR_TEXT: 'UPDATE_VERIFY_INPUT_ERROR_TEXT',
}

export default ACTION;